import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { MaskLines, Reveal, Slug } from "@/components/minka/Motion";
import { Seo } from "@/components/minka/Seo";

const Portrait = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], ["0%", "10%"]);
  return (
    <motion.div initial={{ opacity: 0, scale: 1.05 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }} className="relative">
      <div className="relative aspect-[3/4] overflow-hidden [clip-path:polygon(0_0,100%_4%,100%_100%,0_96%)]">
        <motion.img style={{ y, scale: 1.15 }} src="/img/author.jpg" alt="Portrait of writer Nicola Davis" className="h-full w-full object-cover" data-testid="author-portrait" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#07080B]/80 via-transparent to-transparent" />
      </div>
      <p className="mt-4 font-mono-s text-xs uppercase tracking-[0.25em] text-[#A3ACBB]">Nicola Davis</p>
    </motion.div>
  );
};

export default function Author() {
  return (
    <div className="px-5 pb-32 pt-32 md:px-10 md:pt-40" data-testid="author-section">
      <Seo
        title="Nicola Davis — Writer of MINKA"
        description="Nicola Davis lived five years in Japan teaching Business English for Hitachi in Ibaraki, studying Shintoism, Buddhism and archery. Now the writer of MINKA."
        path="/author"
      />
      <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-[5fr_7fr] lg:items-start">
        <Portrait />
        <div>
          <MaskLines className="font-mono-s text-xs uppercase tracking-[0.35em] text-[#A8DADC]" lines={["The Author · 作家"]} />
          <h1 className="mt-6 font-display text-5xl font-extrabold leading-[0.95] text-[#E2E0D8] sm:text-6xl lg:text-8xl" data-testid="author-name">
            <MaskLines lines={["Nicola", "Davis"]} delay={0.2} />
          </h1>
          <Reveal delay={0.6} className="mt-12 space-y-6">
            <p className="font-serif-i text-2xl leading-snug text-[#E2E0D8] md:text-3xl" data-testid="author-statement">
            “I felt the world is so ready for the next great epic Asian thriller - with elements everyone can relate to set in the mysterious northern mountains of Japan. The more I learned about Japan, the more sinister details I learned that is not even shared with the west; here it is in the raw, with our heroine having to face it head on, but to face off with a samurai, you have to think as cold as they do. . . . There's so much hidden knowledge of the Shinto religion, how it meshes with Buddhism, and those incredibly sinister demons you'll see at some temple grounds or in ancients texts - here brought to life to give our hero the fright - and fight - of her life. And I hope you love the love story where passion boils over and melts that northern snow right off the ground . . .
 I hope you find you're inspired to fight your own fight better, and run after your own dream harder . . .”
          </p>
            <p className="text-base leading-relaxed text-[#C3CAD5] md:text-lg" data-testid="author-bio">
              Nicola Davis lived in Japan while working as a corporate Business English Instructor for Hitachi, Ltd. in Ibaraki Prefecture for more than five years. During this time she traveled extensively, her favorite places to visit being mountain regions and traditional villages they hold which few tourists manage to experience.
            </p>
            <p className="text-base leading-relaxed text-[#C3CAD5] md:text-lg">
              She studied Shintoism, Buddhism, Japanese archery and performed in the All-Japan kimono dressing competition at NHK Hall in Tokyo (3rd place foreign females). Her favorite site in Japan: Nikko.
            </p>
          </Reveal>
          <Reveal className="mt-16 border-t border-white/10 pt-10">
            <Slug>Work available</Slug>
            <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="font-brush text-3xl tracking-[0.2em] text-[#C81D25]">MINKA</p>
                <p className="mt-1 text-sm text-[#A3ACBB]">Feature screenplay · Supernatural Thriller / Horror</p>
              </div>
              <Link to="/film-options" data-testid="author-options-link" className="w-fit rounded-full border border-[#C81D25]/70 px-6 py-3 font-mono-s text-xs uppercase tracking-[0.2em] text-[#E2E0D8] transition-colors duration-300 hover:bg-[#C81D25]">
                Film options →
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
